import { AxiosService } from './../../../../services/axios.service'
import { createPointsConstants } from './create-points.constants'
import { adminActions, toastActions } from '../../../../actions'

const createPoints = ({
	pointsQuantity: value,
	securityKey
}) => async dispatch => {
	dispatch({ type: createPointsConstants.CREATE_POINTS })
	AxiosService.post('admin/criar-pontos', { securityKey, value }).then(
		({ data }) => {
			dispatch(pointsCreated({ errors: data.errors, points: value }))
		}
	)
}

const pointsCreated = ({ errors, points }) => dispatch => {
	dispatch({ type: createPointsConstants.POINTS_CREATED, errors })
	if (!errors || !errors.length) {
		dispatch(toastActions.success({ message: 'Pontos criados com sucesso' }))
		dispatch(adminActions.addViewBalancePoints(points))
	}
}

export { createPoints, pointsCreated }
